import { render, staticRenderFns } from "./TestBankAIGenerator.vue?vue&type=template&id=0fc86b9a&scoped=true"
import script from "./TestBankAIGenerator.vue?vue&type=script&lang=js"
export * from "./TestBankAIGenerator.vue?vue&type=script&lang=js"
import style0 from "./TestBankAIGenerator.vue?vue&type=style&index=0&id=0fc86b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc86b9a",
  null
  
)

export default component.exports